import { createStore } from 'zustand-x';
import { EntityItem } from '@/api/entities/types';
import { UpsellSource } from '../types';
import pick from 'lodash-es/pick';
import { createJSONStorage } from 'zustand/middleware';

type EntitlementStore = {
  // Dev only store values
  devEntitlements: string[];
  devOverride: boolean;
  devOpen: boolean;
  entity: EntityItem | null;

  // User store values
  isRefreshingEntitlements: boolean;
  upsellOfferingModalId: string;
  upsellOfferingModalSource: UpsellSource | null | undefined;
  provisionalEntitlements: string[];
};

export const entitlementsStore = createStore('entitlements')<EntitlementStore>(
  {
    // Dev only store values
    devEntitlements: [],
    devOverride: false,
    devOpen: false,
    entity: null,

    // User store values
    isRefreshingEntitlements: false,
    upsellOfferingModalId: '',
    upsellOfferingModalSource: null,
    provisionalEntitlements: []
  },
  {
    persist: {
      enabled: true,
      partialize: (state) => pick(state, 'provisionalEntitlements'),
      storage: createJSONStorage(() => sessionStorage)
    }
  }
).extendActions((set) => ({
  resetState: () => {
    set.devOpen(false);
    set.devOverride(false);
    set.devEntitlements([]);
    set.entity(null);
    set.upsellOfferingModalSource(null);
  },
  openUpsellModal: (
    offeringId: string,
    source?: UpsellSource | null | undefined
  ) => {
    set.upsellOfferingModalId(offeringId);
    set.upsellOfferingModalSource(source);
  },
  closeUpsellModal: () => {
    set.upsellOfferingModalId('');
    set.upsellOfferingModalSource(null);
  }
}));
